import { render, staticRenderFns } from "./infoExport.vue?vue&type=template&id=15507bb4&scoped=true"
import script from "./infoExport.vue?vue&type=script&lang=js"
export * from "./infoExport.vue?vue&type=script&lang=js"
import style0 from "./infoExport.vue?vue&type=style&index=0&id=15507bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15507bb4",
  null
  
)

export default component.exports